import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { jsx as e } from "react/jsx-runtime";
import { Fonts as o } from "@vds-core/typography";
import { calculateRem as r } from "@vds-core/utilities";
import { ColorTokens as t } from "@vds-tokens/color";
import { TypographyTokens as n } from "@vds-tokens/typography";
import i, { css as a } from "styled-components";
var l = i.div.withConfig({
    displayName: "StyledBadge",
    componentId: "VDS__sc-ttpaf5-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-overflow: ellipsis;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 2px;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  width: auto;\n  height: auto;\n  min-width: 23px;\n  max-width: ", ";\n  padding: 2px 4px;\n  box-sizing: border-box;\n"])), function (_ref) {
    var e = _ref.$fillColor;
    return e;
  }, function (_ref2) {
    var e = _ref2.$textColor;
    return e;
  }, o.VerizonNHGeTX, r(n.fontsize.body[12].value), n.fontweight.bold.value, r(n.lineheight.body[16].value), function (_ref3) {
    var e = _ref3.$maxWidth;
    return e;
  }),
  d = i.div.withConfig({
    displayName: "StyledWrapper",
    componentId: "VDS__sc-ttpaf5-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  ", "\n"])), function (_ref4) {
    var e = _ref4.$maxWidth,
      o = _ref4.$numberOfLines;
    return e && o && a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin: 0;\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    "])), o);
  }),
  u = function u(o) {
    var r = o.fillColor,
      n = o.surface,
      i = o.children,
      a = o.numberOfLines,
      u = o.maxWidth,
      s = o.id;
    return e(l, {
      $fillColor: function () {
        switch (r) {
          case "red":
          default:
            return t.badges.background.red["on".concat(n)].value;
          case "yellow":
            return t.badges.background.yellow["on".concat(n)].value;
          case "green":
            return t.badges.background.green["on".concat(n)].value;
          case "orange":
            return t.badges.background.orange["on".concat(n)].value;
          case "blue":
            return t.badges.background.blue["on".concat(n)].value;
          case "black":
            return t.badges.background.black["on".concat(n)].value;
          case "white":
            return t.badges.background.white["on".concat(n)].value;
        }
      }(),
      $textColor: "red" === r || "black" === r ? t.palette.white.value : "yellow" === r || "white" === r ? t.palette.black.value : "green" === r || "orange" === r || "blue" === r ? t.elements.primary.inverse["on".concat(n)].value : t.elements.primary.ondark.value,
      $maxWidth: u,
      id: s,
      children: e(d, {
        $numberOfLines: a,
        $maxWidth: u,
        children: i
      })
    });
  };
u.defaultProps = {
  fillColor: "red",
  surface: "light"
};
export { u as default };